import { API_BASE_URL } from "../../config";
import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import useFetchUserSeller from "../Utils/useFetchUserSeller";
import { useFetchData } from "../Utils/useFetchData";
import { useNavigate } from "react-router-dom";

const DeliveryMaster = () => {
    const navigate = useNavigate();
    const handleLogout = useCallback(() => {
        localStorage.removeItem("user");
        navigate("/login");
    }, [navigate]);

    const userIds = useFetchUserSeller(handleLogout);
    const { fetchData } = useFetchData(handleLogout);
    const [selectedSeller, setSelectedSeller] = useState(null);
    const [masterList, setMasterList] = useState([]);
    const [newDate, setNewDate] = useState(new Date().toISOString().split('T')[0]);
    const [dayToCount, setDayToCount] = useState(1);
    const [loading, setLoading] = useState(false);

    const baseApi = `${API_BASE_URL}/seller/api/v1/delivery-track-master`;

    const loadMasterList = useCallback(async () => {
        setLoading(true);
        const data = await fetchData(baseApi);
        if (data) {
            setMasterList(data);
        }
        setLoading(false);
    }, [fetchData]);

    useEffect(() => {
        loadMasterList();
    }, [loadMasterList]);

    const handleCreate = async () => {
        if (!selectedSeller) {
            alert("Please select a seller");
            return;
        }
        const payload = {
            sellerId: selectedSeller.value,
            date: newDate,
            dayToCount: parseInt(dayToCount, 10)
        };
        const result = await fetchData(baseApi, "POST", payload);
        if (result) {
            loadMasterList();
            alert("Created successfully");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            await fetchData(`${baseApi}/${id}`, "DELETE");
            loadMasterList();
        }
    };

    const handleTrigger = async (sellerId) => {
        const url = `${baseApi}/trigger/${sellerId}`;
        const result = await fetchData(url, "POST");
        if (result !== null) {
            alert("Tracking population triggered successfully");
        }
    };

    const sellerOptions = (userIds || []).map(user => ({
        value: user.uid,
        label: user.nameuser,
        username: user.username,
    }));

    return (
        <div className="btc-container">
            <h1 className="btc-heading">Delivery Track Master</h1>

            <div className="btc-table-container" style={{ marginBottom: "20px", padding: "20px" }}>
                <h3>Create New Master Record</h3>
                <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                    <div style={{ width: "300px" }}>
                        <Select
                            options={sellerOptions}
                            value={selectedSeller}
                            onChange={setSelectedSeller}
                            placeholder="Select Seller..."
                            isClearable
                        />
                    </div>
                    <input
                        type="date"
                        value={newDate}
                        onChange={(e) => setNewDate(e.target.value)}
                        style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                    />
                    <input
                        type="number"
                        value={dayToCount}
                        onChange={(e) => setDayToCount(e.target.value)}
                        placeholder="Day to count (1-7)"
                        min="1"
                        max="7"
                        style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc", width: "100px" }}
                    />
                    <button className="btc-btn" onClick={handleCreate}>Create</button>
                </div>
            </div>

            <div className="btc-table-container">
                <h3>Master Records</h3>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <table className="btc-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Seller ID</th>
                                <th>Seller Name</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {masterList.map((item) => {
                                const seller = userIds.find(u => u.uid === item.sellerId);
                                return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.sellerId}</td>
                                        <td>{seller ? seller.nameuser : "Unknown"}</td>
                                        <td>{item.date}</td>
                                        <td>
                                            <button 
                                                className="btc-btn btn-sm" 
                                                onClick={() => handleTrigger(item.sellerId)}
                                                style={{ marginRight: "5px", backgroundColor: "#46af38" }}
                                            >
                                                Trigger
                                            </button>
                                            <button 
                                                className="btc-btn btn-sm" 
                                                onClick={() => handleDelete(item.id)}
                                                style={{ backgroundColor: "#dc3545" }}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default DeliveryMaster;
